module.exports = __webpack_public_path__ + "img/pp2.b16cb7d7.png";